// node modules
import 'cookie-store';
import React from 'react';
import { render } from 'react-dom';
import { Provider } from 'mobx-react';
import { configure } from 'mobx';
// modules
import { ThemeProvider } from 'modules/App';
import AnalyticsService from 'modules/Analytics';
import AppService from 'modules/App/service';
import { fundsService as FundsService } from 'modules/Funds/service';
import LiveV2Store from 'modules/WebSocket/modules/LiveV2/store';
import PortfolioV2Store from 'modules/WebSocket/modules/PortfolioV2/store';
import { terminateWorker } from 'modules/BOD/modules/BOD/workers';
import LiveData from 'modules/LiveData';
import ScripsDB from 'modules/Db';
import STORES from './stores/registration';
import { Router } from './routing/Routing';

// styles
import './style.css';

// init analytics (Mixpanel)
AnalyticsService.init();

configure({
  computedRequiresReaction: true,
  enforceActions: 'observed',
});

function App() {
  React.useEffect(() => {
    window.addEventListener('beforeunload', handleBeforeUnload);
    return () => {
      window.removeEventListener('beforeunload', handleBeforeUnload);
    };
  }, []);

  const handleBeforeUnload = () => {
    AppService.dispose();
    LiveV2Store.dispose();
    PortfolioV2Store.dispose();
    FundsService.dispose();
    terminateWorker();
    LiveData.destroy();
    if (ScripsDB.isOpen()) {
      ScripsDB.close();
    }
  };

  return (
    <Provider {...STORES}>
      <ThemeProvider>
        <Router />
      </ThemeProvider>
    </Provider>
  );
}

render(<App />, window.document.getElementById('root'));
